import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { ApplicationFormDetails } from '../../../../../shared/models/application-form-details';
import { ApplicationFormDetailsComponent } from '../application-form-details/application-form-details.component';
import { ApplicationHistoryComponent } from '../application-history/application-history.component';

@Component({
  selector: 'app-admin-panel-application-preview',
  imports: [
    ApplicationFormDetailsComponent,
    ApplicationHistoryComponent,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
  ],
  templateUrl: './admin-panel-application-preview.html',
  styleUrl: './admin-panel-application-preview.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminPanelApplicationPreview {
  protected readonly applicationForm = input<ApplicationFormDetails | null>(
    null,
  );
}
